import { url } from '@ts/utils/url';

/*
Cookie names where to store the time when the sticky banner should be shown.

Notice that sticky banners for secrets links have no cookie, it is shown always.
*/
const COOKIE_EXISTING_SUBSCRIBER = 'df_existing_subscriber';
const COOKIE_NON_SUBSCRIBER = 'df_non_subscriber';

const STICKY_SUBSCRIBER = 'subscriber';
const STICKY_ANONYMOUS = 'anon';

const displayBanner = () => {
  const banners = document.getElementsByClassName(
    'js-abo-banner',
  ) as HTMLCollectionOf<HTMLElement>;

  if (banners.length === 0) return;

  Array.from(banners).forEach(banner => {
    banner.classList.add('bc-abo-banner--opened');
  });
};

const initializeBanner = (cookieName?: string) => {
  if (cookieName === null) {
    displayBanner();
  }

  const position = document.cookie.indexOf(`${cookieName}=`);
  if (position < 0) {
    displayBanner();
  }
};

const saveCookie = (subscriber: boolean) => {
  let name = COOKIE_NON_SUBSCRIBER;
  let time = 3 * 60 * 60; // 3 hours
  if (subscriber) {
    time *= 24; // 3 days
    name = COOKIE_EXISTING_SUBSCRIBER;
  }
  const cookieStr = `${name}=true; max-age=${time}; SameSite=None; Secure`;
  document.cookie = cookieStr;
};

const closeBanner = () => {
  const banners = document.getElementsByClassName(
    'js-abo-banner',
  ) as HTMLCollectionOf<HTMLElement>;

  if (banners.length === 0) return;

  Array.from(banners).forEach(banner => {
    if (!banner) return;
    banner.classList.add('bc-abo-banner--closed');

    const bannerType = banner.dataset.type;
    if (bannerType === STICKY_SUBSCRIBER) {
      saveCookie(true);
    } else if (bannerType === STICKY_ANONYMOUS) {
      saveCookie(false);
    }
  });
};

const handleBanner = (banner: HTMLElement, isDemoPage: boolean) => {
  if (isDemoPage) return;

  const bannerType = banner.dataset.type;
  if (bannerType === STICKY_SUBSCRIBER) {
    initializeBanner(COOKIE_EXISTING_SUBSCRIBER);
  } else if (bannerType === STICKY_ANONYMOUS) {
    initializeBanner(COOKIE_NON_SUBSCRIBER);
  } else {
    // secret links sticky banner
    initializeBanner();
  }
};

export const stickyBanner = () => {
  const banners = document.getElementsByClassName(
    'js-abo-banner',
  ) as HTMLCollectionOf<HTMLElement>;
  if (banners.length === 0) return;

  const baseUrl = url.getBaseUrl();
  const isDemoPage = baseUrl.includes('sticky-banners');
  Array.from(banners).forEach(banner => {
    handleBanner(banner, isDemoPage);
  });

  const closeButtons = document.getElementsByClassName(
    'js-abo-banner-close',
  ) as HTMLCollectionOf<HTMLElement>;
  Array.from(closeButtons).forEach(close_button => {
    close_button.addEventListener('click', closeBanner);
  });
};
